import { supabase } from '@/lib/supabase/client';

function assertSupabase() {
  if (!supabase) {
    throw new Error('Supabase environment variables are not configured.');
  }

  return supabase;
}

export async function joinSlotRpc(eventSlotId: string) {
  const client = assertSupabase();
  return client.rpc('join_slot', { p_event_slot_id: eventSlotId });
}

export async function cancelSignupRpc(eventId: string) {
  const client = assertSupabase();
  return client.rpc('cancel_signup', { p_event_id: eventId });
}

export async function createEventFromTemplateRpc(payload: {
  templateId: string;
  title: string;
  description?: string | null;
  startsAt: string;
  signupOpensAt: string;
  signupClosesAt: string;
}) {
  const client = assertSupabase();
  return client.rpc('create_event_from_template', {
    p_template_id: payload.templateId,
    p_title: payload.title,
    p_description: payload.description ?? null,
    p_starts_at: payload.startsAt,
    p_signup_opens_at: payload.signupOpensAt,
    p_signup_closes_at: payload.signupClosesAt,
  });
}

export async function archiveEventRpc(eventId: string, force = false) {
  const client = assertSupabase();
  return client.rpc('archive_event', {
    p_event_id: eventId,
    p_force: force,
  });
}

export async function adminUpdatePlayerPresentationRpc(payload: {
  profileId: string;
  progressionLevelOverride?: number | null;
  chatMuted?: boolean;
  chatMutedReason?: string | null;
}) {
  const client = assertSupabase();
  return client.rpc('admin_update_player_presentation', {
    p_profile_id: payload.profileId,
    p_progression_level_override: payload.progressionLevelOverride ?? null,
    p_chat_muted: payload.chatMuted ?? false,
    p_chat_muted_reason: payload.chatMutedReason ?? null,
  });
}

export async function adminSetProfileBadgesRpc(profileId: string, badgeSlugs: string[]) {
  const client = assertSupabase();
  return client.rpc('admin_set_profile_badges', {
    p_profile_id: profileId,
    p_badge_slugs: badgeSlugs,
  });
}

export async function adminDeleteGuildChatMessageRpc(messageId: string) {
  const client = assertSupabase();
  return client.rpc('admin_delete_guild_chat_message', {
    p_message_id: messageId,
  });
}

export async function adminClearGuildChatRpc() {
  const client = assertSupabase();
  return client.rpc('admin_clear_guild_chat');
}

export async function completeProfileOnboardingRpc(inGameName: string) {
  const client = assertSupabase();
  return client.rpc('complete_profile_onboarding', {
    p_in_game_name: inGameName,
  });
}

export async function deleteEventPermanentlyRpc(eventId: string, confirmationText: string) {
  const client = assertSupabase();
  return client.rpc('delete_event_permanently', {
    p_event_id: eventId,
    p_confirmation_text: confirmationText,
  });
}

export async function deleteWeaponCatalogItemRpc(weaponId: string, confirmationText: string) {
  const client = assertSupabase();
  return client.rpc('delete_weapon_catalog_item', {
    p_weapon_id: weaponId,
    p_confirmation_text: confirmationText,
  });
}

export async function deleteTemplateRecordRpc(templateId: string, confirmationText: string) {
  const client = assertSupabase();
  return client.rpc('delete_template_record', {
    p_template_id: templateId,
    p_confirmation_text: confirmationText,
  });
}

export async function staffMoveSignupRpc(signUpId: string, targetEventSlotId: string) {
  const client = assertSupabase();
  return client.rpc('staff_move_signup', {
    p_signup_id: signUpId,
    p_target_event_slot_id: targetEventSlotId,
  });
}

export async function staffRemoveSignupRpc(signUpId: string) {
  const client = assertSupabase();
  return client.rpc('staff_remove_signup', {
    p_signup_id: signUpId,
  });
}

export async function refreshEventAttendanceRecordsRpc(eventId?: string) {
  const client = assertSupabase();
  return client.rpc('refresh_event_attendance_records', {
    p_event_id: eventId ?? null,
  });
}
